var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerticalMask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 592,
    height: 84,
    viewBox: "0 0 592 84",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fill: "#000000",
    stroke: "none",
    d: "M 0 0 L 592 0 L 592 69.858704 C 592 69.858704 578.530029 70.224701 563.5 69.858704 C 536.882019 69.210602 512 58 470 58 C 423.493988 58 409.334991 74.237198 363 70.5 C 335.595001 68.289597 314 64 284.5 64 C 222.285004 64 188.589005 74.047302 126.5 69.858704 C 95.599701 67.774101 60.117001 66.3993 44.5 67 C 18.5 68 0 69.858704 0 69.858704 L 0 0 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalMask);
export default __webpack_public_path__ + "static/media/vertical_mask.befaf5c808c4af75f929313aabef1233.svg";
export { ForwardRef as ReactComponent };